import { newSpecPage } from '@stencil/core/testing';
import { LabDsButton } from './lab-ds-button';

describe('v4-button', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [LabDsButton],
      html: `<lab-ds-button size="small" variant="primary" type="button" label="label"/>`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-button label="label" size="small" type="button" variant="primary">
    <mock:shadow-root>
      <button class="button small primary undefined" type="button">
          <span class="label">
              <span class="label-text">
                  label
              </span>
          </span>
        <div class="icon-loading">
          <span class="material-symbols-outlined icon">
              progress_activity
          </span>
        </div
      </button>
    </mock:shadow-root>
    </lab-ds-button>
  `);
  });
  it('renders with default values', async () => {
    const page = await newSpecPage({
      components: [LabDsButton],
      html: `<lab-ds-button/>`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-button>
    <mock:shadow-root>
      <button class="button medium primary undefined" type="button">
        <span class="label"></span>
        <div class="icon-loading">
          <span class="material-symbols-outlined icon">
              progress_activity
          </span>
        </div
      </button>
      </mock:shadow-root>
    </lab-ds-button>
  `);
  });
  it('renders when loading', async () => {
    const page = await newSpecPage({
      components: [LabDsButton],
      html: `<lab-ds-button loading/>`,
    });
    expect(page.root).toEqualHtml(`
    <lab-ds-button loading>
    <mock:shadow-root>
      <button class="button loading medium primary" disabled="" type="button">
        <span class="label"></span>
        <div class="icon-loading">
          <span class="material-symbols-outlined icon">
              progress_activity
          </span>
        </div
      </button>
      </mock:shadow-root>
    </lab-ds-button>
    `);
  });
});
